import React from 'react';

import { Link } from 'react-router-dom';




export default function SparePartsBusinessPackages() {
	return (
		<div>
			<div class="sp-banner">
				<img src="assets/images/service-provider/spare-parts/banner-1.jpg" alt="" class="img-fluid sp-banner-img" />
				<div class="sp-logo">
					<div class="line-a "><img src="assets/images/service-provider/spare-parts/logo.jpg" alt="" class="img-fluid" /></div>
					<div class="line-b">Spare Parts business Name</div>
				</div>
			</div>
	
	
			<div class="main-content-area">
				<div class="container">
					<div class="row justify-content-between">
						<div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
							<div class="side-package">
								<div class="line-Link ">PACKAGE</div>
								<div class="line-b"><div class="side-package-progress"><span class="eighty"></span></div></div>
								<div class="line-c">30 days remaining</div>
								<div class="line-d">Validity till 02 March 2021</div>
								<div class="line-e"><Link class="btn btn-dark btn-sm" href="#" role="button">UPDATE</Link> </div>
							</div>
					
							<div class="side-links-wrap">
								<ul>
									<li><Link to="/sp-spare-parts-business" class="active"><img src="assets/images/icons/sp-business/manage-business.svg" alt="" /> Manage Business</Link> </li>
									<li><Link to="/sp-spare-parts-parts"><img src="assets/images/icons/sp-business/manage-service.svg" alt="" /> Manage Parts</Link> </li>
									<li><Link to="/sp-spare-parts-banner"><img src="assets/images/icons/sp-business/banner.svg" alt="" /> Banner</Link> </li>
									<li><Link to="/sp-spare-parts-working-hours"><img src="assets/images/icons/sp-business/manage-working-hours.svg" alt="" /> Manage Working Hours</Link> </li>
								</ul>
							</div>
						</div>
				
						<div class="col-12 col-sm-12 col-md-9 col-lg-9">
							<h2 class="mb-4">Manage Business</h2>
					
							<h4 class="mb-2">Select Package</h4>
							<h5 class="mb-4">Promote Your Ad to get more Views and Sell Faster</h5>
					
							<div class="row justify-content-center">
								<div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3 mb-sm-3 mb-md-0 mb-lg-0">
									<div class="sp-package sp-package-Link ">
										<div class="line-Link "><img src="assets/images/icons/sp-packages/free.svg" alt="" /></div>
										<div class="line-b">Free Post</div>
										<div class="line-c">5 Days Display your Ad</div>
										<div class="line-d">Free Post</div>
										<div class="line-e">Your ad will display as published date on the category pages over service validity</div>
										<div class="line-f"><Link class="btn btn-block btn-secondary" href="#" role="button" data-toggle="modal" data-target="#payment-method">BUY NOW</Link> </div>
									</div>
								</div>
				
								<div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3 mb-sm-3 mb-md-0 mb-lg-0">
									<div class="sp-package sp-package-b">
										<div class="line-Link "><img src="assets/images/icons/sp-packages/1-month.svg" alt="" /></div>
										<div class="line-b">1 Month</div>
										<div class="line-c">Get 15 times more views</div>
										<div class="line-d">7.000 KD</div>
										<div class="line-e">Your ad will always stay among the top ads of the category pages over service validity</div>
										<div class="line-f"><Link class="btn btn-block btn-secondary" href="#" role="button" data-toggle="modal" data-target="#payment-method">BUY NOW</Link> </div>
									</div>
								</div>
				
								<div class="col-12 col-sm-12 col-md-4 col-lg-4">
									<div class="sp-package sp-package-c">
										<div class="line-Link "><img src="assets/images/icons/sp-packages/6-months.svg" alt="" /></div>
										<div class="line-b">6 Months</div>
										<div class="line-c">Get 30 times more views</div>
										<div class="line-d">20.000 KD</div>
										<div class="line-e">Your ad will always stay among the top ads of the category pages over service validity</div>
										<div class="line-f"><Link class="btn btn-block btn-secondary" href="#" role="button" data-toggle="modal" data-target="#payment-method">BUY NOW</Link> </div>
									</div>
								</div>
							</div>
					
							{/* <!-- Payment Method --> */}
							<div class="modal fade" id="payment-method" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
								<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title" id="exampleModalLabel">Payment Method</h5>
											<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
										</div>
										<div class="modal-body">
											<div class="row">
												<div class="col-auto"><Link to="#" class="payment-button"><img src="assets/images/icons/sp-packages/k-net.png" /> K-Net</Link> </div>
												<div class="col-auto"><Link to="#" class="payment-button"><img src="assets/images/icons/sp-packages/credit-card.png" /> Visa / Master</Link> </div>
											</div>
							
											<form class="mt-4">
												<div class="form-group form-check">
													<input type="checkbox" class="form-check-input" id="exampleCheck1" /><label class="form-check-label" for="exampleCheck1">By continuing you agreed to Terms and Conditions & Privacy Practices</label>
												</div>
											</form>
										</div>
										<div class="modal-footer">
											<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
											<Link class="btn btn-primary" href="#" role="button" data-toggle="modal" data-target="#registration-done" data-dismiss="modal">Pay</Link>
										</div>
									</div>
								</div>
							</div>
							{/* <!-- Payment Method --> */}
			
							{/* <!-- successfully Registered --> */}
							<div class="modal fade" id="registration-done" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
								<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title">successfully Registered</h5>
											<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
										</div>
										<div class="modal-body">
											<div class="row justify-content-center">
												<div class="col-5"><img src="assets/images/icons/registration-done.svg" class="img-fluid" alt="" /></div>
											</div>
							
											<p class="mb-0 mt-4 text-center">You are now successfully Registered</p>
										</div>
						
									</div>
								</div>
							</div>
							{/* <!-- successfully Registered --> */}
				
						</div>
					</div>
				</div>
			</div>
	
	
	
		</div>
	);
};
